;(function () {
	if (
		!WC ||
		WC.idMenu !== 136 ||
		!document.querySelector('.consorzioAsiagoAziende')
	) {
		return
	}

	const now = new Date()
	const cacheBusting =
		now.getFullYear() +
		'-' +
		(now.getMonth() + 1) +
		'-' +
		now.getDate() +
		'-' +
		now.getHours() +
		'-' +
		(now.getMinutes() < 30 ? 0 : 30)

	// fetch(`/api/consorzioFormaggioAsiago.json?cb=${cacheBusting}`)
	// 	.then(res => res.json())
	// 	.then(data => {
	// 		printCAA(data)
	// 	})
	$.getJSON(
		'/api/consorzioAsiagoAziende.json?cb='.concat(cacheBusting),
		printCAA
	)

	function printCAA(data) {
		const caa = document.querySelector('.consorzioAsiagoAziende')
		if (!caa) {
			console.log('Failed to load CAA')
			return
		}

		let html = ''
		Object.keys(data.categories).forEach(catKey => {
			const cat = data.categories[catKey]
			html += `<p class="consorzioAsiagoAziende__title">${mL(
				cat.title
			)}</p>`
			html += '<ul class="consorzioAsiagoAziende__list">'
			cat.items.forEach(item => {
				let pronoun = 'in'
				if (WC.lang.substring(0, 2) === 'it') {
					pronoun =
						item.city.charAt(0).toLowerCase() === 'a' ? 'ad' : 'a'
				}
				html += '<li class="consorzioAsiagoAziende__item">'
				html += '<details class="consorzioAsiagoAziende__details">'
				html += `
					<summary class="consorzioAsiagoAziende__summary">
						<strong>${item.name}</strong>
						${pronoun}
						${item.city}
					</summary>`

				html += '<div class="consorzioAsiagoAziende__contents">'
				if (item.address1) {
					html += `<p class="consorzioAsiagoAziende__address1">${mL(
						data.strings.address1
					)}: ${item.address1}</p>`
				}
				if (item.address2) {
					html += `<p class="consorzioAsiagoAziende__address1">${mL(
						data.strings.address2
					)}: ${item.address2}</p>`
				}
				if (item.phone) {
					html += `<p class="consorzioAsiagoAziende__address1">${mL(
						data.strings.phone
					)}: ${item.phone}</p>`
				}
				if (item.emails) {
					html += `<p class="consorzioAsiagoAziende__address1">${mL(
						data.strings.emails
					)}: ${item.emails}</p>`
				}
				if (item.website) {
					html += `<p class="consorzioAsiagoAziende__address1">${mL(
						data.strings.website
					)}: ${item.website}</p>`
				}
				html += '</div>'

				html += '</details>'
				html += '</li>'
			})
			html += '</ul>'
		})

		caa.innerHTML = html
	}

	function mL(obj) {
		return obj[WC.lang.substring(0, 2)]
	}
})()
